import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';


export default function Cookies() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main className="pt-24 md:pt-28 pb-16 md:pb-20">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="font-heading text-3xl md:text-4xl text-foreground-50 tracking-tighter mb-8">
            Çerez Politikası
          </h1>
          <p className="text-sm text-foreground-500 mb-8">
            Son güncelleme: 7 Ağustos 2026
          </p>

          <div className="space-y-8 text-foreground-300 leading-relaxed">
            <section>
              <h2 className="text-lg font-bold text-foreground-100 mb-3">1. Çerez Nedir?</h2>
              <p className="text-sm md:text-base">
                Çerezler (cookies), ziyaret ettiğiniz web siteleri tarafından tarayıcınıza yerleştirilen küçük metin dosyalarıdır. Site tercihlerinizi hatırlamak, kullanıcı deneyimini iyileştirmek ve site trafiğini analiz etmek için kullanılırlar.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-bold text-foreground-100 mb-3">2. Kullandığımız Çerez Türleri</h2>
              <div className="space-y-3 text-sm md:text-base">
                <p><strong>Zorunlu Çerezler:</strong> Sitenin temel işlevlerini yerine getirmesi için gereklidir. Bunlar olmadan site düzgün çalışmaz.</p>
                <p><strong>Analitik Çerezler:</strong> Ziyaretçilerin siteyi nasıl kullandığını anlamamıza yardımcı olur. Hangi sayfaların popüler olduğunu, kullanıcıların sitede ne kadar kaldığını ölçeriz.</p>
                <p><strong>İşlevsellik Çerezleri:</strong> Tercihlerinizi hatırlayarak size daha kişiselleştirilmiş bir deneyim sunar.</p>
              </div>
            </section>

            <section>
              <h2 className="text-lg font-bold text-foreground-100 mb-3">3. Çerezleri Yönetme</h2>
              <p className="text-sm md:text-base">
                Tarayıcı ayarlarınızdan çerezleri engelleyebilir veya silebilirsiniz. Ancak bazı çerezleri devre dışı bırakmanız site deneyiminizi olumsuz etkileyebilir. Çerez ayarlarını değiştirmek için tarayıcınızın yardım sayfalarını ziyaret edebilirsiniz.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-bold text-foreground-100 mb-3">4. Üçüncü Taraf Çerezleri</h2>
              <p className="text-sm md:text-base">
                Sitemiz, analiz hizmetleri gibi üçüncü taraf araçları kullanabilir. Bu araçlar kendi çerezlerini yerleştirebilir. Üçüncü taraf çerezleri üzerinde doğrudan kontrolümüz yoktur; ilgili hizmet sağlayıcının gizlilik politikasını incelemenizi öneririz.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-bold text-foreground-100 mb-3">5. İletişim</h2>
              <p className="text-sm md:text-base">
                Çerez politikamızla ilgili sorularınız için <strong>info@biffdigital.com</strong> adresinden bizimle iletişime geçebilirsiniz.
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}